export const MIGRATIONS_DIRECTORY = 'migrations'
export const MIGRATION_SCRIPT_EXTENSIONS = ['mjs', 'js', 'ts', 'cjs']
export const DEFAULT_API_VERSION = 'v2024-01-29'
